<template>
	<div>
		<header class="masthead mb-auto">
			<nav class="navbar navbar-expand-lg navbar-dark bg-no-trans ">
				<div class="container">
					<a class="navbar-brand" href="/#/">
						<img src="../../assets/img/logo.png" alt="Logo" />
					</a>
					<div class="my-2 my-lg-0">
						<button
							class="btn btn-light btn-sm my-2 my-sm-0"
							@click="gotoSingin"
						>
							Login
						</button>
					</div>
				</div>
			</nav>
		</header>
		<section class="py-5 bg-grey200">
			<div class="container">
				<div class="row">
					<div class="col-md-12">
						<div class="paymentbox">
							<v-braintree
								v-if="client_token"
								v-bind:authorization="client_token"
								@success="onSuccess"
								@error="onError"
								@load="onLoad"
								:paypal="{ flow: 'vault' }"
							>
								<template v-slot:button="slotProps" v-if="showPaynow">
									<div class="btn-over">
										<button
											class="btn btn-primary btn-sm my-2 my-sm-0"
											@click="slotProps.submit"
										>
											Pay Now
										</button>
									</div>
								</template>
							</v-braintree>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: "BraintreeRenewUpdateCard",
	data: function() {
		return {
			client_token: this.$store.state.btClientToken,
			showPaynow: false,
		};
	},

	created() {
		var Data = {
			token: this.$store.state.user.accessToken,
		};
		this.$store.dispatch("getClientToken", Data).then((res) => {
			if (res) {
				this.$store.commit("setBTClientToken", res.token);
				this.client_token = res.token;
			}
		});
		this.$store.commit("setLoader", true);
	},
	methods: {
		onSuccess(payload) {
			this.$store.commit("setNonceToken", payload.nonce);
			this.$store.commit(
				"setNotification",
				"Payment successful please checkout and start Membership to Continue"
			);
			var dataToSend = {
				id: payload.nonce,
			};
			this.$store
				.dispatch("addPaymentProcess", dataToSend)
				.then((res) => {
					this.$store.commit("setLoader", false);
					if (res.status == 200) {
						self.$store.commit(
							"setNotification",
							" Payment Card Updated Sucessfully!! "
						);
						this.$router.push("/account");
					}
				})
				.catch((err) => {
					this.$store.commit("setLoader", false);
					self.$store.commit("setNotification", " Error while making payment ");
					this.$router.push("/account");
				});
		},
		onError(error) {
			let message = error.message;
			this.$store.commit("setNotification", error.message);
			// Whoops, an error has occured while trying to get the nonce
		},
		gotoSingin() {
			this.$router.push("/login");
		},
		onLoad() {
			this.showPaynow = true;
			this.$store.commit("setLoader", false);
		},
	},
};
</script>

<style scoped>
.paymentbox {
	margin: 0 auto;
	max-width: 40%;
	padding-top: 50px;
}
.btn-primary {
	margin-top: 10px;
}
.btn-over {
	margin-top: 15px;
	width: 100%;
	text-align: center;
}
.py-5 {
	padding-top: 10rem !important;
	padding-bottom: 10rem !important;
}
</style>
